import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpWaveSearchParams from './TpWaveSearchParams';
import TpWaveService from '../../../Services/TpWaveService';
import TpWaveItem from '../../../Domain/TpWaveItem';
import AssociateTpWavePanel from './AssociateTpWavePanel';
import userHelper from '../../../Helpers/userHelper';

export default class TpWaveAdmin extends Component {
  constructor(props) {
    super(props);

    let newSearchItem;
    if (props.ClientId) {
      newSearchItem = new TpWaveSearchParams(props.ClientId);
    } else {
      newSearchItem = new TpWaveSearchParams();
      if (props.ProjectId) {
        newSearchItem.ProjectId = props.ProjectId;
      }
    }

    this.state = {
      searchItem: newSearchItem,
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
    };

    this.bindFunctions();
  }

  bindFunctions() {
    this.handleButtonRowButtonClick = this.handleButtonRowButtonClick.bind(this);
    this.refresh = this.refresh.bind(this);
    TpWaveItem.removeAssociationFunction = this.removeAssociationFunction.bind(this);
    TpWaveItem.clickOnSelect = this.clickOnSelect.bind(this);
    this.handleClickOnStartSearch = this.handleClickOnStartSearch.bind(this);
  }

  clickOnSelect(item) {
    const updatedList = this.state.itemList.map((element) => {
      if (element.TpWaveId === item.TpWaveId) {
        return {
          ...element,
          Selected: !element.Selected,
        };
      }
      return element;
    });

    this.setState({
      itemList: updatedList,
    });
  }

  removeAssociationFunction(id, item, itemList) {
    const edited = { TpWaveIds: [item.TpWaveId], ProjectId: this.props.ProjectId };
    this.callRemoveAssociationService(edited);
  }

  callRemoveAssociationService(edited) {
    ErrorMessage.SetApprove('Are you sure you want to remove the selected wave association?', () =>
      TpWaveService.RemoveWaveAssociation(edited)
        .then((result) => {
          if (result && result !== 'None.') {
            ErrorMessage.SetErrorMessage(result);
          } else {
            ErrorMessage.SetNotification('Successfully removed wave associations.');
          }
          this.refresh();
        })
        .catch((error) => {
          ErrorMessage.SetErrorMessage('TWA76', error);
        })
    );
  }

  refresh() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  handleButtonRowButtonClick(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  handleClickOnStartSearch(searchItem) {
    if (this.props.ProjectId) {
      searchItem.ProjectId = this.props.ProjectId;
    }

    if (this.props.ClientId) {
      searchItem.ClientId = this.props.ClientId;
    }

    return this.setState({ searchItem });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.SomethingElse) {
      this.setState({
        searchItem: {
          ...this.state.searchItem,
          IsActivated: this.state.searchItem.IsActivated === true ? false : true,
        },
      });
      return;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  massRemoveAssociation() {
    const edited = {
      TpWaveIds: this.state.itemList.filter((f) => f.Selected).map((f) => f.TpWaveId),
      ProjectId: this.props.ProjectId,
    };
    this.callRemoveAssociationService(edited);
  }

  renderButtonsAndPanels() {
    return (
      <>
        {!this.props.IsSubClientsView && (
          <FigmaButtonRow
            className={'InnerMenuButtonFigmaList'}
            buttons={[
              {
                iconName: 'fa-solid fa-minus-circle',
                type: ButtonTypeEnum.NormalIconOnly,
                color: ButtonColorsEnum.Destruct,
                iconPosition: IconPositionEnum.Center,
                onClick: () => this.massRemoveAssociation(),
                disabled: !this.state.itemList.find((f) => f.Selected) || !userHelper.isAdmin(),
                tooltip: 'Remove Third-Party Wave Associations',
                roleKey: 'project_edit',
              },
              {
                iconName: 'fa-solid fa-plus-circle',
                type: ButtonTypeEnum.NormalIconOnly,
                color: ButtonColorsEnum.Primary,
                iconPosition: IconPositionEnum.Center,
                onClick: () => this.showPanel(ShownPanelsEnum.AddNewItem),
                tooltip: 'Associate Third-Party Wave',
                disabled: !userHelper.isAdmin(),
                roleKey: 'project_edit',
              },
            ]}
          />
        )}
        {this.renderPanels()}
      </>
    );
  }

  renderAddNewItemPanel() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <AssociateTpWavePanel
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            searchItem={this.state.searchItem}
            isOverWindow={true}
          />
        )}
      </div>
    );
  }

  renderPanels() {
    return <div>{this.renderAddNewItemPanel()}</div>;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpWaveItem}
          itemList={this.state.itemList}
          serviceFunction={TpWaveService.GetTpWaveItemList}
          convertDBItemsFunction={TpWaveService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={TpWaveSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.handleClickOnStartSearch(searchItem)}
          singleSearchLine={false}
          //isExportExcelDisabled={false}
          //clickOnExportExcel={this.handleExportExcelButtonClick}
          singleSearchLinePlaceholder='Search in TpClientLinkId...'
          errorCode='TWA207'
          afterClickOnCancel={() => this.bindFunctions()}
          enableUrlPush={false}
          showPagination={true}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          useClickOnClearAll={this.props.ProjectId}
        />
      </div>
    );
  }
}
